import ChartNivAcuteBuikpijn from "../../../../src/client/niv_acuteboekje/json/acute-buikpijn.json";
import ChartNivSimple from "../../../../src/client/niv_acuteboekje/interactions/simple/ChartNivSimple.js";
import ButtonSchematic from "../../../../src/client/niv_acuteboekje/ui/ButtonSchematic.js";
import * as React from 'react';
export default {
  ChartNivAcuteBuikpijn,
  ChartNivSimple,
  ButtonSchematic,
  React
};